/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit State/view.blocks to change it.
import * as fromData from 'Simple/Data'
import AppointmentBookingState from 'DesignSystem/AppointmentBookingState/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function State({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Agenda/Appointments/Content/Appointment/State"
  
}) {
let appointmentBookingStateValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'state',
})
  return (<React.Fragment
>
<AppointmentBookingState
  viewPath={`${viewPath}/AppointmentBookingState`}
 data="appointment_booking.state"
 state={appointmentBookingStateValueData}
/>
{children}
</React.Fragment>)
}